import React, { useState } from "react"
import certifications from "../../data/certificates.json"
import './certs.css'

export default function Certifications() {
    const [certification, selectCert] = useState(null)

    const getDetails = (id) => {
        const found = certifications.find((p) => p.id === id)
        if (found) selectCert(found)
    }

    const resetState = () => {
        selectCert(null)
    }

    return (
        <>
            <h2>Certifications</h2>
            <div className="cert-map">
                {certification ?
                    <div className="cert-detail">
                        <h2>{certification.title}</h2>
                        <div className="cert-sections">
                            <div className="cert-left">
                                <img src={certification.image} alt={certification.title} />
                            </div>
                            <div className="cert-right">
                                <div className="cert-description">
                                    <p>{certification.description}</p>
                                </div>
                                <div className="cert-tags">
                                    {certification.skills.map((tag) => (
                                        <span key={tag} className="tag">{tag}</span>
                                    ))}
                                </div>
                            </div>
                            
                        </div>
                        <div className="exit-buttons">
                            <p className="view-detail-btn"><a href={certification.url} target="_blank" rel="noopener noreferrer">View</a></p>
                            <p className="detail-btn"><a href="#certs" onClick={resetState}>Return</a></p>
                        </div>
                    </div>
                    :
                    certifications.map((cert) => (
                        <div key={cert.id} className="cert-card">
                            <div className="overlay">
                                <button onClick={() => getDetails(cert.id)}>View</button>
                            </div>
                            <img src={cert.image} alt={cert.title} />
                            <p>{cert.title}</p>
                        </div>
                    ))
                }
            </div>
        </>
    )
}